// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    COMPANY_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        companyIndexPage: action.companyIndexPage
      };
    },
    COMPANY_INDEX_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.companyIndexPage
      };
    },
    COMPANY_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
